<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <path class="cls-3" d="m36.39,36.52c1.17,0,2.17.99,2.17,2.17v35.17c0,1.17-.99,2.17-2.17,2.17h-17.72c-1.17,0-2.17-.99-2.17-2.17v-35.17c0-1.17.99-2.17,2.17-2.17h17.72m0-4h-17.72c-3.39,0-6.17,2.77-6.17,6.17v35.17c0,3.39,2.77,6.17,6.17,6.17h17.72c3.39,0,6.17-2.77,6.17-6.17v-35.17c0-3.39-2.77-6.17-6.17-6.17h0Z"/>
  <path class="cls-4" d="m37.11,14.05c.78,0,1.44.66,1.44,1.44v6.93c0,.78-.66,1.44-1.44,1.44h-19.17c-.78,0-1.44-.66-1.44-1.44v-6.93c0-.78.66-1.44,1.44-1.44h19.17m0-4h-19.17c-2.99,0-5.44,2.45-5.44,5.44v6.93c0,2.99,2.45,5.44,5.44,5.44h19.17c2.99,0,5.44-2.45,5.44-5.44v-6.93c0-2.99-2.45-5.44-5.44-5.44h0Z"/>
  <path class="cls-5" d="m71.4,14.05c1.17,0,2.17.99,2.17,2.17v34.9c0,1.17-.99,2.17-2.17,2.17h-17.72c-1.17,0-2.17-.99-2.17-2.17V16.21c0-1.17.99-2.17,2.17-2.17h17.72m0-4h-17.72c-3.39,0-6.17,2.77-6.17,6.17v34.9c0,3.39,2.77,6.17,6.17,6.17h17.72c3.39,0,6.17-2.77,6.17-6.17V16.21c0-3.39-2.77-6.17-6.17-6.17h0Z"/>
  <path class="cls-4" d="m72.13,66.21c.78,0,1.44.66,1.44,1.44v6.93c0,.78-.66,1.44-1.44,1.44h-19.17c-.78,0-1.44-.66-1.44-1.44v-6.93c0-.78.66-1.44,1.44-1.44h19.17m0-4h-19.17c-2.99,0-5.44,2.45-5.44,5.44v6.93c0,2.99,2.45,5.44,5.44,5.44h19.17c2.99,0,5.44-2.45,5.44-5.44v-6.93c0-2.99-2.45-5.44-5.44-5.44h0Z"/>
  <g>
    <g>
      <rect class="cls-2" x="60.54" y="21.8" width="4" height="12.37" rx="1.24" ry="1.24"/>
      <path class="cls-2" d="m68.46,34.26l-4.65,8.06c-.56.97-1.97.97-2.53,0l-4.65-8.06c-.56-.97.14-2.19,1.26-2.19h9.31c1.12,0,1.83,1.22,1.26,2.19Z"/>
    </g>
    <polyline class="cls-1" points="55.99 40.54 55.99 45.53 69.1 45.53 69.1 40.54"/>
  </g>
</svg>
</template>

<script>
export default {
    name: "DashboardDownloadIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: none;
    stroke: #0f5b71;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2px;
  }
  .cls-2 {
    fill: #0f5b71;
  }
  .cls-3 {
    fill: #187382;
  }
  .cls-4 {
    fill: #b6dfce;
  }
  .cls-5 {
    fill: #65c8c9;
  }
</style>
